var map = {
	"./additionalInfoIcon.svg": 672,
	"./arrowBottomIconSharpSmall.svg": 673,
	"./arrowLeftIcon.svg": 674,
	"./arrowMediumTop.svg": 675,
	"./arrowRightIcon.svg": 676,
	"./arrowRightIconSharp.svg": 677,
	"./arrowRightSmallIcon.svg": 678,
	"./arrowScalableIcon.svg": 679,
	"./arrowSelect2.svg": 680,
	"./arrowSelectIcon.svg": 681,
	"./benefit1.svg": 682,
	"./benefit2.svg": 683,
	"./benefit3.svg": 684,
	"./cardsIcon.svg": 685,
	"./circleInfoIcon.svg": 686,
	"./copyIcon copy.svg": 687,
	"./copyIcon.svg": 688,
	"./crossIcon.svg": 689,
	"./crossIcon2.svg": 690,
	"./crossIcon3.svg": 691,
	"./crossIconSmall.svg": 692,
	"./crossSmallIcon.svg": 693,
	"./defaultCategoryIcon.svg": 694,
	"./depNumberIcon.svg": 695,
	"./elfCentralIcon.svg": 696,
	"./equalitySign.svg": 697,
	"./errorIcon.svg": 698,
	"./eyeClosedIcon.svg": 699,
	"./eyeOpenIcon.svg": 700,
	"./favoritesIcon.svg": 701,
	"./favoritesLabelIcon.svg": 702,
	"./filterDivider.svg": 703,
	"./filterIcon.svg": 704,
	"./frequencyIcon.svg": 705,
	"./fsAmountIcon.svg": 706,
	"./fullScreenIcon.svg": 707,
	"./gameIcon.svg": 708,
	"./gemIcon.svg": 709,
	"./goldGiftIcon.svg": 710,
	"./hamburgerIcon.svg": 711,
	"./infoIcon.svg": 712,
	"./infoIconSmall.svg": 713,
	"./infoSymbol.svg": 714,
	"./levelBackground.svg": 715,
	"./levelBackgroundNew.svg": 716,
	"./linkIcon.svg": 717,
	"./lockIcon.svg": 718,
	"./lockSharpIcon.svg": 719,
	"./maxBonusAmountIcon.svg": 720,
	"./maxWinFsIcon.svg": 721,
	"./menu/fortuneIcon.svg": 446,
	"./menu/fortuneIconL.svg": 447,
	"./menu/helpdeskIcon.svg": 448,
	"./menu/helpdeskIconL.svg": 449,
	"./menu/homeIcon.svg": 450,
	"./menu/homeIconLarge.svg": 451,
	"./menu/jackpotIcon.svg": 452,
	"./menu/logo.svg": 453,
	"./menu/logoSmall.svg": 454,
	"./menu/loyaltyIcon.svg": 455,
	"./menu/mobileAppIcon.svg": 456,
	"./menu/profileIcon.svg": 457,
	"./menu/questIcon.svg": 458,
	"./menu/questsIcon.svg": 459,
	"./menu/rewardLineupIcon.svg": 460,
	"./menu/searchIcon.svg": 461,
	"./menu/searchIconLarge.svg": 462,
	"./menu/signOutIcon.svg": 463,
	"./menu/star.svg": 464,
	"./menu/tournamentIcon.svg": 465,
	"./menu/tournamentLargeIcon.svg": 466,
	"./menu/vipIcon.svg": 467,
	"./menu/wheelIcon.svg": 468,
	"./menu/wheelIconL.svg": 469,
	"./menu/wheelIconMobile.svg": 470,
	"./menuIcon.svg": 722,
	"./minDepIcon.svg": 723,
	"./minusIcon.svg": 724,
	"./noTournamentIcon.svg": 725,
	"./numbers/number-1.svg": 471,
	"./numbers/number-2.svg": 472,
	"./numbers/number-3.svg": 473,
	"./numbers/number-4.svg": 474,
	"./numbers/number-5.svg": 475,
	"./numbers/number-6.svg": 476,
	"./numbers/number-7.svg": 477,
	"./numbers/number-8.svg": 478,
	"./numbers/number-9.svg": 479,
	"./numbers/number-shine-1.svg": 480,
	"./numbers/number-shine-2.svg": 481,
	"./numbers/number-shine-3.svg": 482,
	"./numbers/number-shine-4.svg": 483,
	"./numbers/number-shine-5.svg": 484,
	"./numbers/number-shine-6.svg": 485,
	"./numbers/number-shine-7.svg": 486,
	"./numbers/number-shine-8.svg": 487,
	"./numbers/number-shine-9.svg": 488,
	"./playIcon.svg": 726,
	"./plusIcon.svg": 727,
	"./polygon.svg": 728,
	"./preloaderDotsAnimation.svg": 729,
	"./preloaderSpinnerAnimation.svg": 730,
	"./present2Icon.svg": 731,
	"./presentIcon.svg": 732,
	"./promoIcon.svg": 733,
	"./recentIcon.svg": 734,
	"./search2Icon.svg": 735,
	"./search3Icon.svg": 736,
	"./sharpTickIcon copy.svg": 737,
	"./sharpTickIcon.svg": 738,
	"./smallInfoSymbol.svg": 739,
	"./smoothArrowIcon.svg": 740,
	"./successIcon.svg": 741,
	"./supportIcon.svg": 742,
	"./tag1Icon.svg": 743,
	"./tag2Icon.svg": 744,
	"./tag3Icon.svg": 745,
	"./tag4Icon.svg": 746,
	"./tickIcon.svg": 747,
	"./unverified.svg": 748,
	"./verified.svg": 749,
	"./wagerIcon.svg": 750,
	"./wagerTimeIcon.svg": 751,
	"./warningIcon.svg": 752,
	"./zoomIcon.svg": 753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 671;